import { IAddNewApportionment } from "../Interfaces";
import {
  ItemTypeIds,
  TransactionTexts,
  TransTypes,
  GroupTextTypes,
  TransactionGroupId,
} from "../Constant";
import dayjs from "dayjs";
import { Guid } from "guid-typescript";

export function AddApportionmentReturnToDebtor(this: IAddNewApportionment) {
  const isCourtFee = TransactionGroupId.COURT_FEE == this.transactionGroupId;

  return {
    amount: this.amountValue,
    amountBureuVat: 0,
    amountCreditorVat: 0,
    accountNo:
      this.typeId == ItemTypeIds.RETURN_TO_DEBTOR
        ? this.itemsInfo.accountNo
        : "",
    apportionId: 0,
    arId: !isCourtFee ? this.mainPayment.arId : 0,
    bureauAmount:
      this.typeId == ItemTypeIds.RETURN_FEE || !isCourtFee
        ? this.amountValue
        : 0,
    caseId: !isCourtFee ? this.mainPayment.caseId : 0,
    caseNo: !isCourtFee ? this.mainPayment.caseNo : "",
    caseType: !isCourtFee ? this.mainPayment.caseType : "",
    itemIndex: !isCourtFee ? this.mainPayment.itemIndex : 1,
    parentIndex: !isCourtFee ? this.mainPayment.parentIndex : 1,
    childIndex: !isCourtFee ? this.mainPayment.childIndex + 1 : 0,
    creditorAmount: 0,
    debtorAmount:
      this.typeId == ItemTypeIds.RETURN_TO_DEBTOR ? this.amountValue : 0,
    exceedAmount: 0,
    groupText: "",
    provisionText: this.transactionText,
    invoiceNo: !isCourtFee ? this.mainPayment.invoiceNo : "",
    isInterest: !isCourtFee ? this.mainPayment.isInterest : false,
    isRemitted: false,
    itemTypeId: this.typeId,
    journalId: "",
    key: !isCourtFee
      ? Guid.create().toString()
      : "ch - " + `${this.itemsInfo.itemsLength + 1}`,
    modifiedDate: dayjs(),
    modifiedUser: this.mainPayment.currentUser.email,
    otherAmount: 0,
    paymentAmount: this.mainPayment.paymentAmount,
    paymentArItemNo: 0,
    paymentId: this.mainPayment.paymentId,
    transactionProfileNo: 0,
    ref: null,
    remitVoucherNo: 0,
    subcaseId: 0,
    text: this.text,
    transType:
      this.typeId == ItemTypeIds.RETURN_TO_DEBTOR
        ? TransTypes.RETURN_TO_DEBTOR
        : !isCourtFee
        ? TransTypes.MAIN_AMOUNT_INTEREST
        : "",
    transactionArItemNo: !isCourtFee ? this.mainPayment.transactionArItemNo : 0,
    transactionBalance: 0,
    transactionGroupId: "0",
    transactionText:
      this.typeId == ItemTypeIds.EXCEEDED_AMOUNT
        ? TransactionTexts.EXCEEDED_AMOUNT
        : this.typeId == ItemTypeIds.RETURN_FEE
        ? TransactionTexts.RETURN_FEE
        : this.typeId == ItemTypeIds.RETURN_TO_DEBTOR
        ? TransactionTexts.RETURN_TO_DEBTOR
        : TransactionTexts.PROVISION,
    vatAmount: 0,
    vatBasis: 0,
    vatCode: !isCourtFee ? this.mainPayment.vatCode : 0,
    vatDeducted: 0,
    vatLiable: true,
    vatPaidByDebtor: 0,
    vatRate: 25,
    vatStatus: !isCourtFee ? this.mainPayment.vatStatus : "",
    isProvision: !isCourtFee,
    isNew: true,
  };
}
